export enum UserStatus {
  Invited = 'invited',
  Active = 'active',
  Disabled = 'disabled',
}
